<template>
<div>
    <bar-manut 
        single-entity="Conta" 
        :crud="this.crud" 
        @closeform="closeForm" 
        @save="handleSave">
    </bar-manut>

    <br>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="cta.codcta" :metadata="metadata.cta.codcta" type="text" col="2" :disabled="true"></form-field>
                
                <form-field v-model="cta.descricao" type="text" col="4" :metadata="metadata.cta.descricao" 
                    name="descricao" :v-errors="errors" v-validate="metadata.cta.descricao.validator"></form-field>
                
            </div>
            <div class="row">
                <form-field v-model="cta.tipocta" type="select" col="2" :metadata="metadata.cta.tipocta"></form-field>
                <form-field v-model="cta.ctapadrao" type="select" col="2" :metadata="metadata.cta.ctapadrao"
                    name="ctapadrao" :v-errors="errors" v-validate="metadata.cta.ctapadrao.validator"></form-field>
                <form-field v-model="cta.codfil" :tabindex="-1" type="select2" col="3" :metadata="metadata.cta.codfil"
                    name="codfil" :v-errors="errors" v-validate="metadata.cta.codfil.validator"></form-field>
            </div>
            <label-title v-if="cta.tipocta==='B'" title="Dados Bancários"></label-title>
            <div class="row" v-if="cta.tipocta==='B'">
                <form-field v-model="cta.banco" type="select" col="3" :select-options="bancoOptions" label="Banco" @input="setCtaValidate(cta.banco)"></form-field>
            </div>
            <div class="row" v-if="bancoHomologado">
                <input-switch type="success" label="Emite Boleto?" v-model="cta.emiteboleto" value-checked="S" value-unchecked="N" :metadata="metadata.cta.emiteboleto"></input-switch>
                <!-- <form-field v-model="cta.emiteboleto" type="select" col="2" :metadata="metadata.cta.emiteboleto"
                    name="emiteboleto" :v-errors="errors" v-validate="metadata.cta.emiteboleto.validator"></form-field> -->
            </div>
            <div v-if="cta.emiteboleto==='S'">
                <label-title title="Configuração para emissão de boletos"></label-title>
                <br>
                <alert type="info" 
                    text="Assista ao vídeo com instruções para configuração da emissão de boleto e envio de cobrança escritural."></alert>
                <div class="row col">
                    <span class="data-list">Para emissão de boleto será obrigatório o envio do arquivo de remessa no qual contém informações sobre os boletos emitidos aos clientes.</span>
                    <span class="data-list">O arquivo de remessa deve ser gerado após a emissão do boleto.</span>
                    <span class="data-list">O gerente da sua conta deve ser acionado para que seja feita a homologação do arquivo de remessa gerado pelo Nota Brasil.</span>
                </div>
                <br>
                <div class="row">
                    <form-field v-model="cta.agencia" type="text" col="2" :metadata="metadata.cta.agencia" 
                        name="agencia" :v-errors="errors" v-validate="metadata.cta.agencia.validator"></form-field>
                    <form-field v-model="cta.digitoagencia" type="text" col="2" :metadata="metadata.cta.digitoagencia" 
                        name="digitoagencia" :v-errors="errors" v-validate="ctaValidate.digitoagencia.validate"
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.digitoagencia.exibe"></form-field>
                    <form-field v-model="cta.conta" type="text" col="2" :metadata="metadata.cta.conta" 
                        name="conta" :v-errors="errors" v-validate="ctaValidate.conta.validate"
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.conta.exibe"></form-field>
                    <form-field v-model="cta.digito" type="text" col="2" :metadata="metadata.cta.digito" 
                        name="digito" :v-errors="errors" v-validate="metadata.cta.digito.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="cta.tparquivocnab" type="select" col="2" :metadata="metadata.cta.tparquivocnab"
                        name="tparquivocnab" :v-errors="errors" v-validate="metadata.cta.tparquivocnab.validator"></form-field>
                        <form-field v-model="cta.numbordero" type="text" col="2" :metadata="metadata.cta.numbordero" 
                        name="numbordero" :v-errors="errors" v-validate="metadata.cta.numbordero.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="cta.carteira" type="text" col="2" :metadata="metadata.cta.carteira" 
                        name="carteira" :v-errors="errors" v-validate="ctaValidate.carteira.validate"
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.carteira.exibe"></form-field>
                    <form-field v-model="cta.carteiravariacao" type="text" col="2" :metadata="metadata.cta.carteiravariacao" 
                        name="carteiravariacao" :v-errors="errors" v-validate="ctaValidate.carteiravariacao.validate"
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.carteiravariacao.exibe"></form-field>
                    <form-field v-model="cta.nrinscricao" type="text" col="2" :metadata="metadata.cta.nrinscricao" 
                        name="nrinscricao" :v-errors="errors" v-validate="ctaValidate.nrinscricao.validate" 
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.nrinscricao.exibe"></form-field>
                    <form-field v-model="cta.convenio" type="text" col="2" :metadata="metadata.cta.convenio" 
                        name="convenio" :v-errors="errors" v-validate="ctaValidate.convenio.validate"
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.convenio.exibe"></form-field>
                    <form-field v-model="cta.nossonumero" type="text" col="2" :metadata="metadata.cta.nossonumero" 
                        name="nossonumero" :v-errors="errors" v-validate="metadata.cta.nossonumero.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="cta.especietitulo" type="text" col="2" :metadata="metadata.cta.especietitulo" 
                        name="especietitulo" :v-errors="errors" v-validate="ctaValidate.especietitulo.validate"
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.especietitulo.exibe"></form-field>
                    <div class="col-md-3">
                        <input-checkbox :label="metadata.cta.emissaoempresa.label" v-model="cta.emissaoempresa" 
                        v-validate="ctaValidate.emissaoempresa.validate" value-checked="S" 
                        :value-unchecked="
                            ctaValidate.emissaoempresa.validate.required 
                                ? null 
                                : 'N' 
                        "
                        v-if="ctaValidate.emissaoempresa.exibe"></input-checkbox>
                        <small class="error" v-if="emissaoEmpresaError">{{emissaoEmpresaError.msg}}</small>
                    </div>
                </div>
                <div class="row">
                    <form-field v-model="cta.pmulta" type="value" col="2" :metadata="metadata.cta.pmulta" 
                        name="pmulta" :v-errors="errors" v-validate="metadata.cta.pmulta.validator"></form-field>
                    <form-field v-model="cta.pmora" type="value" col="2" :metadata="metadata.cta.pmora" 
                        name="pmora" :v-errors="errors" v-validate="metadata.cta.pmora.validator"></form-field>
                    <form-field v-model="cta.codinstr1" type="number" col="2" :metadata="metadata.cta.codinstr1"
                        name="codinstr1" :v-errors="errors" v-validate="ctaValidate.codinstr1.validate" 
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.codinstr1.exibe"></form-field>
                    <form-field v-model="cta.codinstr2" type="number" col="2" :metadata="metadata.cta.codinstr2"
                        name="codinstr2" :v-errors="errors" v-validate="ctaValidate.codinstr2.validate" 
                        v-if="ctaValidate && ctaValidate.digitoagencia && ctaValidate.codinstr2.exibe"></form-field>
                </div>
                <br>
                <div class="row col">
                    <span class="data-list">Configure abaixo as mensagens que serão impressas no boleto</span>
                </div>
                <br>
                <div class="row">
                    <form-field v-model="cta.instrucao1" type="text" col="6" :metadata="metadata.cta.instrucao1" 
                        name="instrucao1" :v-errors="errors" v-validate="metadata.cta.instrucao1.validator"></form-field>
                    <form-field v-model="cta.instrucao2" type="text" col="6" :metadata="metadata.cta.instrucao2" 
                        name="instrucao2" :v-errors="errors" v-validate="metadata.cta.instrucao2.validator"></form-field>
                    <form-field v-model="cta.localpag1" type="text" col="6" :metadata="metadata.cta.localpag1" 
                        name="localpag1" :v-errors="errors" v-validate="metadata.cta.localpag1.validator"></form-field>
                    <form-field v-model="cta.localpag2" type="text" col="6" :metadata="metadata.cta.localpag2" 
                        name="localpag2" :v-errors="errors" v-validate="metadata.cta.localpag2.validator"></form-field>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDS, apiORDSpost, urlODS } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            cta: {...this.$store.getters.getEntities.cta},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            bancoList: [],
            bancoOptions: [],
            ctaValidate: {},
        }
    },

    computed: {
        emissaoEmpresaError: function (){
            return this.errors.items.find(er=> er.field == 'emissaoempresa')
        },
        editing: function () {
            return this.crud == SysVars.crudU
        },

        tipocta: function () {
            return this.cta.tipocta
        },

        bancoHomologado: function () {
            //PESQUISA SE O BANCO SELECIONADO PERMITE EMISSAO DE BOLETO
            if (this.cta.tipocta==='B') {
                var banco = this.bancoList.find(banco => banco.banco === this.cta.banco);
                return banco && banco.cnab === 'S'
            } else { 
                return false 
            }
        },

    },

    watch: {
        tipocta: function(value) {
            if (this.tipocta != 'B') {
                this.cta.emiteboleto = 'N'
                this.cta.banco = ''
            }
        },
    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.cta.codcta)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                        //Array de erros está trazendo campo emissaoempresa como nulo  
                        this.errors.items.map(er => {
                            if(er.field == null){
                                er.field = 'emissaoempresa'
                            }
                        })
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao

            //carrega lista de bancos
            await this.$store.dispatch('loadBanco')
            if (this.$store.getters.getBancoList) {
                this.bancoList = this.$store.getters.getBancoList
                this.bancoOptions = this.$store.getters.getBancoList.map(function (obj) {
                    return { id: obj.banco, text: obj.nome }
                })
            }

            if (this.crud == SysVars.crudI) {
                this.cta.tipocta = 'B'
                this.cta.tparquivocnab = '1'
                this.cta.emiteboleto = 'N'
                this.cta.ctapadrao = 'N'
                return
            }

            await this.$store.dispatch('loadCta', { id: this.index } )
            if (this.$store.getters.getCta) {
                this.cta = {...this.$store.getters.getCta}
                this.setCtaValidate(this.cta.banco)
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/cta/' + this.cta.codcta

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/cta/'
            var sendData = {}
            sendData = { cta: this.cta }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                modulo = modulo + this.cta.codcta
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
                this.errmessages = data.errmessages
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

        setCtaValidate(bancoId) {
            console.log('A conta selecionada é: ' + bancoId)

            if (!bancoId) {
                const ctaValidate = {
                    nrinscricao: { exibe: false, validate: { required: false } },
                    convenio: { exibe: false, validate: { required: false } },
                    carteira: { exibe: false, validate: { required: false } },
                    carteiravariacao: { exibe: false, validate: { required: false } },
                    conta: { exibe: false, validate: { required: false } },
                    digitoagencia: { exibe: false, validate: { required: false } },
                    emissaoempresa: { exibe: false, validate: { required: false } },
                    especietitulo: { exibe: false, validate: { required: false } },
                    codinstr1: { exibe: false, validate: { required: false } },
                    codinstr2: { exibe: false, validate: { required: false } },
                }
                
                this.ctaValidate = ctaValidate
            }else{
                const ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: false } },
                    convenio: { exibe: true, validate: { required: false } },
                    carteira: { exibe: true, validate: { required: false } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: false } },
                    digitoagencia: { exibe: true, validate: { required: false } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: false } },
                    codinstr1: { exibe: true, validate: { required: false } },
                    codinstr2: { exibe: true, validate: { required: false } },
                }
                
                this.ctaValidate = ctaValidate
 
            }

            // banco do brasil 
            if (bancoId == '001') {

                const ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: false, max: 20 } },
                    convenio: { exibe: true, validate: { required: true, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, min: 1, max: 3 } },
                    carteiravariacao: { exibe: true, validate: { required: false, min: 1, max: 3 } },
                    conta: { exibe: true, validate: { required: true, max: 5 } },
                    digitoagencia: { exibe: true, validate: { required: false, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } },
                }
                
                this.ctaValidate = ctaValidate
            }


            // Bradesco
            if (bancoId == '237') {

                const ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: true, max: 20 } },
                    convenio: { exibe: true, validate: { required: false, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, max: 2 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: true, max: 5 } },
                    digitoagencia: { exibe: true, validate: { required: false, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } },
                }
                
                this.ctaValidate = ctaValidate
            }

            // Itaú
            if (bancoId == '341') {

                const ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: true, max: 20 } },
                    convenio: { exibe: true, validate: { required: false, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, min: 3, max: 3 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: true, max: 5 } },
                    digitoagencia: { exibe: false, validate: { required: false, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } },
                }
                
                this.ctaValidate = ctaValidate
            }

            // Santander
            if (bancoId == '033') { //ta dando erro por causa do 0

                const ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: true, max: 20 } },
                    convenio: { exibe: true, validate: { required: false, max: 20 } },
                    carteira: { exibe: true, validate: { required: true, max: 1 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    conta: { exibe: true, validate: { required: true, min: 7, max: 9 } },
                    digitoagencia: { exibe: true, validate: { required: true, max: 1 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    codinstr1: { exibe: true, validate: { required: false, max: 2 } },
                    codinstr2: { exibe: true, validate: { required: false, max: 2 } },
                }
                
                this.ctaValidate = ctaValidate
            }

            // Caixa
            if (bancoId == '104') { //ta dando erro por causa do 0

                const ctaValidate = {
                    nrinscricao: { exibe: true, validate: { required: true, min: 6, max: 6 } },
                    convenio: { exibe: true, validate: { required: true, min: 6, max: 6 } },
                    carteira: { exibe: true, validate: { required: true, max: 2 } },
                    carteiravariacao: { exibe: true, validate: { required: false } },
                    especietitulo: { exibe: true, validate: { required: true, max: 2 } },
                    emissaoempresa: { exibe: true, validate: { required: false } },
                    //campos nao necessarios para o layout 400:
                    conta: { exibe: true, validate: { required: false } },
                    digitoagencia: { exibe: true, validate: { required: false } },
                    codinstr1: { exibe: true, validate: { required: false } },
                    codinstr2: { exibe: true, validate: { required: false } },
                }

                this.ctaValidate = ctaValidate
            }

        }

    },

    components: {

    },
    created () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.loadData();
        this.setCtaValidate();
        this.crudText = this.$crudText(this.crud)

        
    }

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/forms/cta-form.vue